function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m312 136v146.742a48 48 0 1 0 32 45.258v-168l112-16v106.742a48 48 0 1 0 32 45.258v-192z",
  fill: "#3397e8"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 296,
  cy: 328,
  fill: "#e9eef2",
  r: 16
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 440,
  cy: 296,
  fill: "#e9eef2",
  r: 16
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m88 48v154.742a48 48 0 1 0 32 45.258v-173.82l80-18.18v-32z",
  fill: "#2978b8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 248,
  fill: "#e9eef2",
  r: 16
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m168 264v130.742a48 48 0 1 0 32 45.258v-176z",
  fill: "#a3d4f7"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 440,
  fill: "#e9eef2",
  r: 16
});

function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.0ef72478.svg";
export { ForwardRef as ReactComponent };